import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { useUiStore } from '../store/uiStore.js';
import {
  ensureCatalog,
  onCatalogLoaded,
  translate,
  type TranslateParams,
  type TranslationKey,
} from './index.js';

export type Translate = (key: TranslationKey, params?: TranslateParams) => string;

/**
 * Hook de traduction.
 *
 * Deux raisons de se re-rendre, et pas une : la langue change, ou son catalogue
 * vient d'arriver. Sans la seconde, un joueur non francophone resterait sur le
 * repli francais jusqu'au prochain rendu declenche par autre chose.
 */
export function useT(): Translate {
  const language = useUiStore((state) => state.language);
  const version = useSyncExternalStore(onCatalogLoaded, getVersion, getVersion);

  useEffect(() => ensureCatalog(language), [language]);

  return useCallback(
    (key: TranslationKey, params?: TranslateParams) => translate(language, key, params),
    // `version` ne sert qu'a invalider le callback quand un catalogue arrive :
    // il n'est pas lu, il declenche.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [language, version],
  );
}

/**
 * Compteur de catalogues charges, qui sert d'instantane a
 * `useSyncExternalStore`. Il doit etre STABLE entre deux appels sans
 * changement, sinon React boucle sur un rendu infini.
 */
let version = 0;
onCatalogLoaded(() => {
  version += 1;
});
function getVersion(): number {
  return version;
}
